export default "query publicationLanguages{\n    publicationLanguages\n}";